import React, { useState, useEffect } from "react";
import { Input, Modal, Form, Button, Select } from "antd";
import { noop, isEmpty } from "lodash";
import TextArea from "antd/lib/input/TextArea";

const CatalogLabFormModal = ({
  data = {},
  columnData,
  visible,
  submitText,
  title,
  onCancel,
  ...props
}) => {
  const [imageUrl, setImageUrl] = useState(columnData && columnData.pic_url);

  const [form] = Form.useForm();
  const { Option } = Select;

  const onOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        await props.onSubmit(values);
        onCancel();
        setImageUrl("");
        // form.resetFields();
        if (isEmpty(data)) {
          form.resetFields();
        }
      })
      .catch(noop);
  };
  const onModalCancel = () => {
    // if (!isEmpty(data)) {
    //   form.resetFields();
    // }
    form.resetFields();
    setImageUrl("");
    onCancel();
  };
  const modalFooter = (
    <Button onClick={onOk} type="primary">
      {submitText}
    </Button>
  );

  useEffect(() => {
    form.resetFields();
    setImageUrl(columnData && columnData.pic_url);
  }, []);

  return (
    <Modal
      visible={visible}
      onCancel={onModalCancel}
      onOk={onOk}
      title={title}
      okText={submitText}
      destroyOnClose
      footer={modalFooter}
      {...props}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={onOk}
      >
        <Form.Item
          label="Process Name"
          name="title"
          rules={[
            { required: true, message: "Please input Process Name!" },
            { max: 25, message: "Name must be maximum 25 characters." },
          ]}
        >
          <Input size="large" placeholder="Enter Process Name" />
        </Form.Item>
        <Form.Item
          label="Description"
          name="subtitle"
          rules={[{ required: true, message: "Please input Description!" }]}
        >
          <TextArea rows={4} size="large" placeholder="Enter Description" />
        </Form.Item>
        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select status!" }]}
        >
          <Select size="large" placeholder="Status - Active / Blocked">
            <Option value>Active</Option>
            <Option value={false}>Blocked</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CatalogLabFormModal;
